// alterado - revisado

import React, { useState } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import LABEL from '../../../business-const/Label/Label'

import ClienteService from '../../../business-api/ClienteService'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivEntradaDados,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    GridContainer,
    GridItem6,
    GridItem8sm12xs12,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import { 
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    ButtonVisualizarPDFTipoPoliticaInvestimento,
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsViewPDF,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    pesquisaList,
    pesquisaDescricaoList,
} from '../../../business-rules/List/ListService'

import tipoPoliticaInvestimentoList from '../../../business-rules/List/tipoPoliticaInvestimentoList'

import tipoArquivoList from '../../../business-rules/List/Arquivo/tipoArquivoList'

import {
    getArquivoByGrupoArquivoTipoArquivoConteudo,
} from '../../arquivo/ArquivoService'



const FormFormPerfilCliente = ({ variaveisGlobais, values, handleChange, handleSubmit, idConfiguracao }) => {

    const [pdf, setPdf] = useState(null)

    const obterPDFTipoPoliticaInvestimento = async ( tipoPoliticaInvestimentoCliente ) => {

        setPdf(null)

        if (tipoPoliticaInvestimentoCliente) {

            const tipoArquivo =
                pesquisaList(tipoPoliticaInvestimentoList, tipoPoliticaInvestimentoCliente).tipoArquivo

            const grupoArquivo =
                pesquisaList(tipoArquivoList, tipoArquivo).grupoArquivo

            const arquivoArquivoAcessoDTO = await getArquivoByGrupoArquivoTipoArquivoConteudo(variaveisGlobais,
                ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais), grupoArquivo, tipoArquivo, idConfiguracao, null, null)

            setPdf(arquivoArquivoAcessoDTO.conteudo)
        }
    }

    useSingleton(async () => {

        obterPDFTipoPoliticaInvestimento(values.tipoPoliticaInvestimentoCliente)
    })

    return (
        <ValidatorFormPadrao
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <GridContainer
                className="justify-center"
            >   
                <GridItem8sm12xs12>
                    <CardGridEntradaDados>
                        <CardGridDivHeaderEntradaDados>
                            <CardGridDivEntradaDados>
                                {LABEL.perfilCliente}
                            </CardGridDivEntradaDados>
                        </CardGridDivHeaderEntradaDados>

                        <CardGridDivBodyEntradaDados>
                            <GridContainer>
                                <GridItem6>
                                    <TextFieldTextSelect
                                        name="tipoPoliticaInvestimentoCliente"
                                        label={LABEL.tipoPoliticaInvestimento}
                                        value={values.tipoPoliticaInvestimentoCliente || ''}
                                        onChange={(e) => {
                                            obterPDFTipoPoliticaInvestimento(e.target.value)
                                            handleChange(e)
                                        }}
                                        list={tipoPoliticaInvestimentoList}
                                    />
                                </GridItem6>
                            </GridContainer>

                            {values.tipoPoliticaInvestimentoCliente
                                ?
                                    <>
                                        <GridContainer>
                                            <GridItem12>
                                                <div
                                                    className="m-0 text-muted text-12"
                                                    dangerouslySetInnerHTML={{ __html: 
                                                        pesquisaList(tipoPoliticaInvestimentoList,
                                                            values.tipoPoliticaInvestimentoCliente)
                                                                .descricaoDetalhada
                                                    }}
                                                />
                                            </GridItem12>
                                        </GridContainer>
                                            
                                        <br/>

                                        {pdf
                                            ?
                                                <GridContainer>
                                                    <GridItem12>
                                                        <CustomizedDialogsViewPDF
                                                            maxWidth='xl'
                                                            popupTitle={pesquisaDescricaoList(tipoPoliticaInvestimentoList,
                                                                values.tipoPoliticaInvestimentoCliente)
                                                            }
                                                            PopupButton={ButtonVisualizarPDFTipoPoliticaInvestimento}
                                                            pdfFile={pdf}
                                                        />
                                                    </GridItem12>
                                                </GridContainer>
                                            :
                                                ''
                                        }
                                    </>
                                :
                                    ''
                            }
                        </CardGridDivBodyEntradaDados>
                    </CardGridEntradaDados>
                </GridItem8sm12xs12>
            </GridContainer>
        </ValidatorFormPadrao>
    )
}

export default FormFormPerfilCliente